import { useTags } from "@/queries/episodes/use-tags";
import { Button, FormControl, MenuItem, Select, SxProps } from "@mui/material";
import { useState } from "react";

type TagsDropdownProps = {
  value?: string;
  tagsToExclude?: string[];
  onChange: (tagId: string) => void;
  variant?: "text" | "outlined" | "contained";
  label?: string;
  sx?: SxProps;
  disabled?: boolean;
};

export function TagsDropdown({
  value,
  tagsToExclude = [],
  onChange,
  label = "+ Add tag",
  variant = "outlined",
  sx,
  disabled,
}: TagsDropdownProps) {
  const { data: tags, isLoading } = useTags();
  const [open, setOpen] = useState(false);

  const filteredTags = tags?.filter((tag) => !tagsToExclude.includes(tag));

  if (isLoading) {
    return null;
  }

  return (
    <FormControl
      sx={{
        textWrap: "nowrap",
        flexShrink: 0,
        position: "relative",
        ...sx,
      }}
    >
      <Button
        variant={variant}
        sx={sx}
        disabled={filteredTags?.length === 0 || disabled}
        onClick={() => setOpen(true)}
      >
        {label}
      </Button>
      <Select
        value={value || ""}
        onChange={(e) => onChange(e.target.value as string)}
        label={label}
        disabled={filteredTags?.length === 0 || disabled}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        size="small"
        sx={{ opacity: 0, position: "absolute", width: "100%" }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        {filteredTags!.map((tag) => (
          <MenuItem key={tag} value={tag}>
            {tag}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
